import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// FastAPI devuelve `detail` como array de objetos en errores 422. Si se pasa tal cual a un toast,
// React lanza "Objects are not valid as a React child" y la página se queda en blanco.
// Se normaliza a texto para que todos los toast.error(...detail) sean seguros.
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const d = err?.response?.data?.detail;
    if (d && typeof d !== "string") {
      err.response.data.detail = Array.isArray(d)
        ? d.map((x) => `${(x?.loc || []).filter((l) => l !== "body").join(".")}: ${x?.msg || ""}`.trim()).join(" · ")
        : JSON.stringify(d);
    }
    return Promise.reject(err);
  }
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
